import { StepsLayout } from "@/components/layout/StepsLayout";
import { VideoTrimmer } from "@/components/file/VideoTrimmer";
import { useMedia } from "@/contexts/MediaContext";

export const BuildLayout = ({
    Sidebar,
    VisualArea,
    BottomContent
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) => {
    const { mediaItemToTrim } = useMedia();

    return (
        <>
            <StepsLayout Sidebar={Sidebar} VisualArea={VisualArea} BottomContent={BottomContent} />
            {/* Video Trimmer Modal */}
            {mediaItemToTrim?.validation?.needsTrimming === true && <VideoTrimmer />}
        </>
    );
};
